module.exports = __webpack_public_path__ + "img/Pierre-Emerick Aubameyang.22367087.png";